import { initEnv } from '@front/common/src/utils/env';

const APP_NAME = 'Wecasa pro signup';

initEnv(process.env.REACT_APP_ENV);

export default {
  ENABLE_REDUX_LOGGER: process.env.REACT_APP_ENABLE_REDUX_LOGGER,
  SENTRY_API_KEY: process.env.REACT_APP_SENTRY_API_KEY,
  APP_NAME,
};
